import SignLanguageIcon from "@mui/icons-material/SignLanguage";

export const stepsSearchLSE = [
    {
        selector: '[data-tour="tourCam_1"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Introducción
                </h4>
                <p className="sig_Tour_Content">
                ¡Bienvenid@ a SignaMed! En esta guía te mostraremos cómo utilizar la aplicación para realizar búsquedas utilizando LSE.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_2"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Permisos
                </h4>
                <p className="sig_Tour_Content">
                SignaMed necesita tu permiso para utilizar la cámara de tu dispositivo. Si no lo has hecho todavía, acepta la petición para habilitar la grabación.
                </p>
            </div>
        ),
        position: [20, 20]
    },
    {
        selector: '[data-tour="tourCam_2b"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Cámara
                </h4>
                <p className="sig_Tour_Content">
                Si dispones de varias cámaras en tu dispositivo, puedes seleccionar cuál quieres usar para la grabación.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_3"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Controles
                </h4>
                <p className="sig_Tour_Content">
                Antes de comenzar a grabar, puedes variar la duración del vídeo que se enviará al servidor.
                </p>
            </div>
        ),
        stepInteraction: true,
    },
    {
        selector: '[data-tour="tourCam_4"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Controles
                </h4>
                <p className="sig_Tour_Content">
                Esta opción te permite activar o desactivar la guía de encuadre correcto que se muestra sobre el vídeo.
                </p>
            </div>
        ),
        stepInteraction: true,
    },
    {
        selector: '[data-tour="tourCam_5"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Controles
                </h4>
                <p className="sig_Tour_Content">
                El proceso de grabación comenzará cuando pulses el botón de grabar. 
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_6"]',
        content: () => (
            <div>
                <div className='sig_Home_TourCountdownContainer'>
                    <p className='sig_Home_TourCountdownTitle'>Grabando en...</p>
                    <p className='sig_Home_TourCountdown'>3</p>
                </div>
                <div className="sig_Tour_Container">
                    <h4 className="sig_Tour_Title">
                    Búsqueda en LSE - Grabación
                    </h4>
                    <p className="sig_Tour_Content">
                    Tras pulsar en grabar aparecerá un contador, y cuando este llegue a 0, empezará la grabación del signo. Puedes usar estos segundos para prepararte.
                    </p>
                </div>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_7"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Resultado
                </h4>
                <p className="sig_Tour_Content">
                Tras grabar el signo, se te mostrará el resultado antes de enviarlo a nuestro servidor.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_7b"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Resultado
                </h4>
                <p className="sig_Tour_Content">
                Si no estas satisfech@, puedes repetir la grabación del signo.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_8"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Resultado
                </h4>
                <p className="sig_Tour_Content">
                ¡Y eso es todo! Cuando estés content@ con los resultados, envíanos el vídeo y te mostraremos el signo que se ha detectado.
                </p>
            </div>
        )
    },
];

export const stepsRecordVariant = [
    {
        selector: '[data-tour="tourCam_1"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Grabación de Variantes - Introducción
                </h4>
                <p className="sig_Tour_Content">
                En esta guía te mostraremos cómo utilizar la interfaz para grabar una nueva variante.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_2"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Grabación de Variantes - Permisos
                </h4>
                <p className="sig_Tour_Content">
                SignaMed necesita tu permiso para utilizar la cámara de tu dispositivo. Si no lo has hecho todavía, acepta la petición para habilitar la grabación.
                </p>
            </div>
        ),
        position: [20, 20]
    },
    {
        selector: '[data-tour="tourCam_2b"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Grabación de Variantes - Navegación
                </h4>
                <p className="sig_Tour_Content">
                En cualquier momento, puedes utilizar este botón para volver a la ventana de variantes del signo que has seleccionado. Desde aquí, los pasos son los mismos que para la búsqueda en LSE. 
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_3"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Grabación de Variantes - Controles
                </h4>
                <p className="sig_Tour_Content">
                Antes de comenzar a grabar, puedes variar la duración del vídeo que se enviará al servidor.
                </p>
            </div>
        ),
        stepInteraction: true,
    },
    {
        selector: '[data-tour="tourCam_4"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Grabación de Variantes - Controles
                </h4>
                <p className="sig_Tour_Content">
                Esta opción permite activar o desactivar la ayuda al encuadre que se muestra sobre el vídeo.
                </p>
            </div>
        ),
        stepInteraction: true,
    },
    {
        selector: '[data-tour="tourCam_5"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Grabación de Variantes - Controles
                </h4>
                <p className="sig_Tour_Content">
                El proceso de grabación comenzará cuando pulses el botón de grabar. 
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_6"]',
        content: () => (
            <div>
                <div className='sig_Home_TourCountdownContainer'>
                    <p className='sig_Home_TourCountdownTitle'>Grabando en...</p>
                    <p className='sig_Home_TourCountdown'>3</p>
                </div>
                <div className="sig_Tour_Container">
                    <h4 className="sig_Tour_Title">
                    Grabación de Variantes - Grabación
                    </h4>
                    <p className="sig_Tour_Content">
                    Tras pulsar en grabar aparecerá un contador, y cuando este llegue a 0, empezará la grabación del signo. Puedes usar estos segundos para prepararte.
                    </p>
                </div>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_7"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Grabación de Variantes - Resultado
                </h4>
                <p className="sig_Tour_Content">
                Tras grabar el signo, se te mostrará el resultado antes de enviarlo a nuestro servidor.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_7b"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda en LSE - Resultado
                </h4>
                <p className="sig_Tour_Content">
                Si no estas satisfech@, puedes repetir la grabación del signo.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourCam_8"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Grabación de Variantes - Resultado
                </h4>
                <p className="sig_Tour_Content">
                ¡Y eso es todo! Cuando estés content@ con los resultados, envíanos el vídeo y te devolveremos a la pantalla del signo que seleccionaste.
                </p>
            </div>
        )
    },
];

export const stepsSearchText = [
    {
        selector: '[data-tour="tourText_1"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda por texto - Introducción
                </h4>
                <p className="sig_Tour_Content">
                En esta guía te mostraremos las distintas opciones de la lista de términos de SignaMed.
                </p>
            </div>
        )
    },
    {
        selector: '.MuiDataGrid-row:first-child',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda por texto - Términos
                </h4>
                <p className="sig_Tour_Content">
                Cada fila de la lista te muestra un resumen de los datos de cada término. Pulsando la fila se abrirá la ventana de información del signo.
                </p>
            </div>
        )
    },
    {
        selector: '.MuiDataGrid-row:first-child svg:first-of-type',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda por texto - Términos
                </h4>
                <div className="sig_Tour_Content">
                    <p>El símbolo que encontrarás en el lateral de cada fila indica la capacidad que tiene SignaMed para reconocer ese signo.</p>
                    <div className="sig_Tour_Content_Row">
                        <SignLanguageIcon className='sig_ST_SignIconGREEN' />
                        <span>El sistema reconoce el signo correctamente.</span>
                    </div>
                    <div className="sig_Tour_Content_Row">
                        <SignLanguageIcon className='sig_ST_SignIconYELLOW' />
                        <span>El sistema todavía no reconoce algunas variantes del signo.</span>
                    </div>
                    <div className="sig_Tour_Content_Row">
                        <SignLanguageIcon className='sig_ST_SignIconRED' />
                        <span>El sistema todavía no puede reconocer el signo.</span>
                    </div>
                </div>
            </div>
        )
    },
    {
        selector: '[data-tour="tourText_4"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda por texto - Búsqueda
                </h4>
                <p className="sig_Tour_Content">
                Puedes refinar los resultados de la lista mediante la barra de búsqueda y las opciones de filtros.
                </p>
            </div>
        )
    },
    {
        selector: '.MuiTablePagination-root',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda por texto - Navegación
                </h4>
                <p className="sig_Tour_Content">
                Por último, puedes acceder a los controles de navegación al final de la lista de términos.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourText_1"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda por texto - Fin
                </h4>
                <p className="sig_Tour_Content">
                ¡Eso es todo! Si tienes dudas acerca de la información de cada signo, puedes acceder al tutorial en su ventana emergente.
                </p>
            </div>
        )
    },
];

export const stepsSignDialog = [
    {
        selector: '[data-tour="tourSign_1"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Términos - Introducción
                </h4>
                <p className="sig_Tour_Content">
                En esta guía te mostraremos las distintas partes de la ventana emergente de términos.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourSign_2"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Términos - Favoritos
                </h4>
                <p className="sig_Tour_Content">
                Pulsando este botón podrás añadir este término a tu lista de favoritos para acceder a él rápidamente desde el menú.
                </p>
            </div>
        ),
        stepInteraction: true
    },
    {
        selector: '[data-tour="tourSign_3"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Términos - Secciones
                </h4>
                <p className="sig_Tour_Content">
                De izquierda a derecha, podrás acceder al <b>signo</b> asociado al término, su <b>definición</b> en LSE, y las distintas <b>variantes</b> del signo que tenemos registradas.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourSign_4"]',
        content: 'Overwritten content'
    },
];

export const stepsSignSearch = [
    {
        selector: '[data-tour="tourSign_1"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Búsqueda - Introducción
                </h4>
                <p className="sig_Tour_Content">
                En esta guía te mostraremos las distintas partes de la ventana emergente tras una búsqueda en LSE.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourSign_2"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Términos - Favoritos
                </h4>
                <p className="sig_Tour_Content">
                Pulsando este botón podrás añadir este término a tu lista de favoritos para acceder a él rápidamente desde el menú.
                </p>
            </div>
        ),
        stepInteraction: true
    },
    {
        selector: '[data-tour="tourSign_3"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Términos - Secciones
                </h4>
                <p className="sig_Tour_Content">
                De izquierda a derecha, podrás acceder al signo asociado al término, su definición en LSE, y las distintas variantes del signo que tenemos registradas.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourSign_3b"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Términos - Resultados
                </h4>
                <p className="sig_Tour_Content">
                En este apartado te mostraremos los resultados de la búsqueda, así como el nivel de coincidencia detectado por SignaMed.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourSign_3c"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Términos - Resultados
                </h4>
                <p className="sig_Tour_Content">
                Puedes pulsar cada uno de los resultados para acceder al signo correspondiente.
                </p>
            </div>
        ),
        stepInteraction: true
    },
    {
        selector: '[data-tour="tourSign_3c"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Términos - Colaboración
                </h4>
                <p className="sig_Tour_Content">
                Si quieres ayudarnos a mejorar SignaMed, puedes hacer click en este botón tras seleccionar el resultado correcto de tu búsqueda para enviarnos un reporte.
                </p>
            </div>
        ),
    },
    {
        selector: '[data-tour="tourSign_4"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Términos - Colaboración
                </h4>
                <p className="sig_Tour_Content">
                Por último, si quieres ayudarnos a mejorar el sistema de reconocimiento automático, también puedes grabarte signando alguna de las variantes, o bien registrar una nueva.
                </p>
            </div>
        )
    },
];

export const stepsBugReport = [
    {
        selector: '[data-tour="tourBug_1"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Incidencias - Introducción
                </h4>
                <p className="sig_Tour_Content">
                En esta guía te mostraremos las distintas partes de la sección de Reportes de Incidencias.
                </p>
            </div>
        )
    },
    {
        selector: '[data-tour="tourBug_2"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Incidencias - Nuevo reporte
                </h4>
                <p className="sig_Tour_Content">
                Pulsando en este botón, se abrirá la ventana de reporte de nuevas incidencias.
                </p>
            </div>
        ),
        stepInteraction: true,
        highlightedSelectors: ['[data-tour="tourBug_3"]'],
        mutationObservables: ['.sig_Drawer_SettingsModal_Root']
    },
    {
        selector: '[data-tour="tourBug_3"]',
        content: 'Overwritten content',
    },
    {
        selector: '[data-tour="tourBug_4"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Incidencias - Visibilidad
                </h4>
                <p className="sig_Tour_Content">
                Por defecto, te mostraremos solamente los reportes generados por ti. Para ver los de otros usuarios, puedes pulsar este botón.
                </p>
            </div>
        ),
        stepInteraction: true,
    },
    {
        selector: '[data-tour="tourBug_5"]',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Incidencias - Filtros
                </h4>
                <p className="sig_Tour_Content">
                Pulsando este botón podrás filtrar las incidencias para sólo mostrar aquellas que te interesen.
                </p>
            </div>
        )
    },
    {
        selector: '.sig_BugReport_ST',
        content: () => (
            <div className="sig_Tour_Container">
                <h4 className="sig_Tour_Title">
                Incidencias - Fin
                </h4>
                <p className="sig_Tour_Content">
                Por último, haciendo click en uno de los reportes podrás acceder a la página detallada de incidencias, donde podrás ver mensajes relacionados e información adicional.
                </p>
            </div>
        ),
        position: 'top'
    },
];

// MOB - I usually preffer to set the styles directly in css, but this extension uses various dom elements without class or id
// names, so for now this is the best option to access some parts of its content.
export const tourStyles = {
    maskArea: (base) => ({ 
        ...base, 
        rx: 10 
    }),
    badge: (base) => ({ 
        ...base, 
        backgroundColor: '#3399e9' 
    }),
    dot: (base) => ({ 
        ...base,     
        '--reactour-accent': '#1b9bff',
    }),
    arrow: (base) => ({ 
        ...base,     
    }),
} 